import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import login from '../routes/login/modules/reducer'
import signup from '../routes/signup/modules/signup'
import requestEdit from  '../routes/requestEdit/modules/requestEdit'
import { LOGOUT } from '../modules/actions'
import chat from  '../modules/chat'
import settings from  '../modules/settings'
import candidates from '../routes/candidates/modules/candidates'
import opinion from '../routes/opinion/modules/reducer'
import payments from '../routes/payments/modules/payments'
import emailConfirmation from '../routes/emailConfirmation/modules/emailConfirmation'
import requestConfirmation from '../routes/requestConfirmation/modules/reducer'
import notification from '../modules/notificationReducer'
import resetPassword from '../routes/resetPassword/modules/reducer'
import authenticationCodeConfirmation from '../routes/authenticationCodeConfirmation/modules/authenticationCodeConfirmation'

const appReducer = combineReducers({
  router: routerReducer,
  login,
  signup,
  chat,
  settings,
  candidates,
  requestEdit,
  opinion,
  payments,
  emailConfirmation,
  requestConfirmation,
  notification,
  resetPassword,
  authenticationCodeConfirmation,
})

// @see https://netbasal.com/how-to-secure-your-users-data-after-logout-in-redux-30468c6848e8
const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js